import './styles.css';
import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Paper, Grid } from '@material-ui/core';

import { yupResolver } from '@hookform/resolvers/yup';

import RegistroBasico from './RegistroBasico';

import schema from './schema';

import { useStyles } from './baseStyle';

function Signup(props) {
  const classStyles = useStyles(props);

  const methods = useForm({
    mode: 'onBlur',
    defaultValues: { sexo: '', termsOfService: false },
    resolver: yupResolver(schema),
  });

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      className={classStyles.grid}
    >
      <Paper elevation={10} className={classStyles.root}>
        <div className={classStyles.logoContainer}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            className={classStyles.logo}
          />
        </div>
        <FormProvider {...methods}>
          <RegistroBasico />
        </FormProvider>
      </Paper>
    </Grid>
  );
}

export default Signup;
